import ModusignProxy from "@/proxies/ModusignProxy"
import Vue from "vue"
import moment from 'moment'

const cteateDocWithTemplate = ( {templateId, companySeq, companyName, title, rmsDamdang, rmsDamdangSeq} ) => {

    const params = {
        templateId,
        document: {
            title
        },
        metadatas: [
            {key: 'companySeq', value: String(companySeq) }, 
            {key: 'companyName', value: companyName },
            {key: 'rmsDamdangSeq', value: String(rmsDamdangSeq) },
            {key: 'rmsDamdang', value: rmsDamdang },
            {key: 'year', value: moment().format('YYYY')},
            {key: 'docKind', value: 'T' },
        ]
    }

    return new ModusignProxy()
    .createDocWithTemplate( JSON.stringify(params) )


}

const cteateDocWithUpload = ( { title, companySeq, companyName, rmsDamdang, rmsDamdangSeq} ) => {

    const params = {
        title,
        metadatas: [
            {key: 'companySeq', value: String(companySeq) }, 
            {key: 'companyName', value: companyName },
            {key: 'rmsDamdangSeq', value: String(rmsDamdangSeq) },
            {key: 'rmsDamdang', value: rmsDamdang },
            {key: 'year', value: moment().format('YYYY')},
            {key: 'docKind', value: 'U' },
        ]
    }

    return new ModusignProxy()
    .cteateDocWithUpload( JSON.stringify(params) )


}

const updateMetadataAPI = ( { id, companySeq, companyName, rmsDamdang, rmsDamdangSeq, dockKind, year}  ) => {

    const params = {
        metadatas: [
            {key: 'companySeq', value: String(companySeq) }, 
            {key: 'companyName', value: companyName },
            {key: 'rmsDamdangSeq', value: String(rmsDamdangSeq) },
            {key: 'rmsDamdang', value: rmsDamdang },
            {key: 'year', value: year || moment().format('YYYY')},
            {key: 'docKind', value: dockKind || 'T' },
        ]
    }

    return new ModusignProxy()
    .updateMetatdata( id, JSON.stringify(params) )


}

export {
    cteateDocWithTemplate,
    cteateDocWithUpload,
    updateMetadataAPI
}